import { Component, OnInit, inject, signal } from '@angular/core';
import { RouterLink } from '@angular/router';
import { AuthService } from '../../services/auth.service';
import { QuestionCatalogService } from '../../services/question-catalog.service';
import { QuestionPoolSummary } from '../../models/question-catalog.model';

import { appEnvironment } from '../../app-environment';

@Component({
  selector: 'app-question-catalog',
  standalone: true,
  imports: [RouterLink],
  template: `
    <section class="section question-catalog-page">
      <div class="page-title-block question-catalog-heading">
        <h1>FRAGENKATALOG</h1>
        <span class="title-line"></span>
      </div>

      @if (auth.isAdmin()) {
        @if (isLoading()) {
          <article class="card accent-card no-access-card">
            <h2>Lade Fragenkatalog...</h2>
          </article>
        } @else if (errorMessage()) {
          <article class="card accent-card no-access-card">
            <h2>Backend nicht erreichbar</h2>
            <p>{{ errorMessage() }}</p>
          </article>
        } @else {
          <section class="question-pool-grid">
            @for (pool of pools(); track pool.id) {
              <a class="question-pool-card card accent-card" [routerLink]="['/fragenkatalog', pool.id]">
                <div class="pool-card-head clean-pool-head">
                  <h2>{{ pool.title }}</h2>
                  <span>Öffnen</span>
                </div>

                <div class="pool-stats">
                  <div>
                    <strong>{{ pool.totalQuestions }}</strong>
                    <span>Anzahl Fragen</span>
                  </div>
                  <div>
                    <strong>{{ pool.playedQuestions }}</strong>
                    <span>Gespielt</span>
                  </div>
                  <div>
                    <strong>{{ pool.unusedQuestions }}</strong>
                    <span>Nicht verwendet</span>
                  </div>
                </div>
              </a>
            } @empty {
              <article class="card accent-card no-access-card">
                <h2>Noch keine Spielshow-Tabellen</h2>
                <p>Im Backend wurden noch keine Fragenpools gefunden.</p>
              </article>
            }
          </section>
        }
      } @else {
        <article class="card accent-card no-access-card">
          <h2>Kein Zugriff</h2>
          <p>Der Fragenkatalog ist aktuell nur für Admins sichtbar.</p>
          <a routerLink="/login" class="button primary">Einloggen</a>
        </article>
      }
    </section>
  `
})
export class QuestionCatalogComponent implements OnInit {
  readonly auth = inject(AuthService);
  private readonly catalog = inject(QuestionCatalogService);

  readonly pools = signal<QuestionPoolSummary[]>([]);
  readonly isLoading = signal(false);
  readonly errorMessage = signal('');

  ngOnInit(): void {
    if (this.auth.isAdmin()) {
      this.loadPools();
    }
  }

  private loadPools(): void {
    this.isLoading.set(true);
    this.errorMessage.set('');

    this.catalog.getPools().subscribe({
      next: pools => {
        this.pools.set(pools);
        this.isLoading.set(false);
      },
      error: () => {
        this.errorMessage.set(`Bitte prüfe, ob das Backend unter ${appEnvironment.backendLabel} läuft.`);
        this.isLoading.set(false);
      }
    });
  }
}
